import { useState, useEffect } from "react";

const CboVarAlumnos = ({ selectedValue, onChange, disabled }) => {
    
  const [varAlumnos, setVarAlumnos] = useState([])

  useEffect(() => {
    
      var json3;
      var jsons3;
     var url3;
    let consulta = new Object();
  
    consulta.grupo = 1;
    consulta.empresa = 1;
    
    jsons3 = JSON.stringify(consulta);


    var options3 = {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'

    },
    mode: 'cors',
    credential : 'include',
    body:  jsons3,
    
    };

    url3 = `${process.env.REACT_APP_API_URL}/var/allalumnos`;
        
        
                   
                fetch(url3, options3)
                .then( response => response.json())
                .then( data => {
                
                json3 = data.data;
                setVarAlumnos(json3);
                console.log("Variables de alumnos", json3[0]);
                   
                })
    

    },[]);
  
  
  return (
   
      <select className="form-control form-select mb-3 " value={selectedValue} onChange={onChange}  disabled={disabled}  >
         <option value="0"></option>

      { varAlumnos.map (( unolista, index ) => (   
        <option  key={index+'_opt'} value={unolista.Val_IdVal}>{/*unolista.Val_Nombre + '-' + */unolista.Val_Descrip}</option>
      )
      )
    }

      </select>
  );
};

export default CboVarAlumnos;